<script lang="ts">
    import {getInjector} from 'src/core';
    import {SubSearchLinksDataService} from './sub-search-links.data-service';
    import KpLink from '../kp-link/KpLink.svelte';

    const dataService = getInjector().getByClass(SubSearchLinksDataService);
</script>

{#await dataService.fetchLinks() then links}
    <ul class="sub-search-links-list">
        {#each links as link}
            <li class="sub-search-link">
                <KpLink {link} class={link.class} title={link.title}></KpLink>
            </li>
        {/each}
    </ul>
{/await}

<style lang="less">
    .sub-search-links-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: right;
        column-gap: 20px;
        margin-top: 8px;
    }
</style>